import React from "react"
import styled from "styled-components"
import { DataLoading } from "@pga/pga-component-library"
import {
  DashboardContainer,
  ContentGrid,
  MainContent,
  SidebarContent,
} from "./Styles/Dashboard.styles"

const LoadingCard = styled.div`
  width: 100%;
  padding: 24px;
  background: white;
  box-shadow: 0px 5px 10px rgba(0, 35, 75, 0.15);
  display: flex;
  flex-direction: column;
  gap: 16px;
`

const ProfileLoadingCard = styled(LoadingCard)`
  min-height: 128px;
  justify-content: center;
`

const ContentLoadingCard = styled(LoadingCard)`
  min-height: 400px;
`

const Loading = () => (
  <DashboardContainer>
    <ProfileLoadingCard>
      <DataLoading h={96} />
    </ProfileLoadingCard>
    <ContentGrid>
      <MainContent>
        <ContentLoadingCard>
          <DataLoading h={60} />
          <DataLoading h={60} />
          <DataLoading h={60} />
          <DataLoading h={60} />
        </ContentLoadingCard>
      </MainContent>
      <SidebarContent>
        <ContentLoadingCard>
          <DataLoading h={40} />
          <DataLoading h={40} />
          <DataLoading h={40} />
          <DataLoading h={40} />
          <DataLoading h={40} />
        </ContentLoadingCard>
      </SidebarContent>
    </ContentGrid>
  </DashboardContainer>
)

export default Loading
